




























import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.primaryEnergyConsumption.perSqm",
            inputName: "primary-energy-consumption-per-sqm",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","GARAGE","OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        primaryEnergyConsumptionPerSqm: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(eLevelPerSqm: number): void {
            this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": eLevelPerSqm});
        },
    },
});
